var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("search-header", {
    attrs: {
      narrow: _vm.narrow,
      "use-offset-when-stuck": _vm.useHeaderOffset,
      "root-margin": _vm.headerRootMargin,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ isStuck }) {
          return [
            _c(
              "div",
              { class: ["gfu-project-search-header", { "is-stuck": isStuck }] },
              [
                _c(
                  "div",
                  { staticClass: "gfu-project-search-header__content" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "_ttr",
                        attrs: {
                          theme: "searchPrimary",
                          width: "compact",
                          weight: "thin",
                          shadow: "tight",
                          "data-qa": "filters-button",
                        },
                        on: { click: _vm.onFiltersClick },
                      },
                      [
                        _c("base-icon", {
                          staticClass: "_tc--accent _mr-1",
                          attrs: { name: "sliders-simple" },
                        }),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.Resources.Search.SearchFiltersHeader)
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.selectedFiltersCount > 0
                          ? [
                              _vm._v(
                                "\n                    (" +
                                  _vm._s(_vm.selectedFiltersCount) +
                                  ")\n                "
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "base-button",
                      {
                        staticClass: "_ttr",
                        attrs: {
                          theme: "searchPrimary",
                          width: "compact",
                          weight: "thin",
                          shadow: "tight",
                          "data-qa": "sorting-options-button",
                        },
                        on: { click: _vm.onSortClick },
                      },
                      [
                        _c("base-icon", {
                          staticClass: "_tc--accent _mr-1",
                          attrs: { name: "bars-sort" },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.Resources.Search.SearchFiltersSortLabel)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "strong",
                          {
                            attrs: {
                              "data-qa":
                                "sorting-options-button-selected-sorting",
                            },
                          },
                          [_vm._v(_vm._s(_vm.sortDisplayName))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.filtersWithDisplayNames, function (filter) {
                      return _c(
                        "base-button",
                        {
                          key: filter.key,
                          staticClass: "_ttr",
                          attrs: {
                            width: "compact",
                            weight: "thin",
                            shadow: "tight",
                            theme: "searchSecondary",
                            "data-qa": `filter-button:${filter.key}`,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onDeleteClick(filter)
                            },
                          },
                        },
                        [
                          filter.group
                            ? _c(
                                "span",
                                {
                                  attrs: {
                                    "data-qa": `filter-group:${filter.group}`,
                                  },
                                },
                                [_vm._v(_vm._s(filter.group) + ":")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "strong",
                            {
                              attrs: {
                                "data-qa": `filter-label:${filter.displayName}`,
                              },
                            },
                            [_vm._v(_vm._s(filter.displayName))]
                          ),
                          _vm._v(" "),
                          _c("base-icon", {
                            staticClass: "_ml-1 _tc--lighter",
                            attrs: {
                              name: "window-close",
                              "data-qa": "close-button",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }